import * as React from "react";
const SvgFiRrPersonSeat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21 23a1 1 0 0 1-1 1h-1.246a2.01 2.01 0 0 1-1.923-1.451l-1.378-4.824a1.005 1.005 0 0 0-.962-.725H10c-1.654 0-3-1.346-3-3V8a1 1 0 1 1 2 0v2h6a1 1 0 1 1 0 2H9v2c0 .552.449 1 1 1h4.491c1.332 0 2.519.895 2.885 2.175L18.754 22H20a1 1 0 0 1 1 1M8.5 5C9.879 5 11 3.879 11 2.5S9.879 0 8.5 0A2.5 2.5 0 0 0 6 2.5C6 3.879 7.121 5 8.5 5M13 19h-3c-2.757 0-5-2.243-5-5V8a1 1 0 1 0-2 0v6c0 3.859 3.14 7 7 7h3a1 1 0 1 0 0-2"
    />
  </svg>
);
export default SvgFiRrPersonSeat;
